import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import Layout from './components/Layout/Layout';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/Dashboard';
import ParcelList from './pages/parcels/ParcelList';
import ParcelDetail from './pages/parcels/ParcelDetail';
import ParcelForm from './pages/parcels/ParcelForm';
import Measurements from './pages/measurements/Measurements';
import Weather from './pages/weather/Weather';
import Chat from './pages/chat/Chat';
import ImportsExports from './pages/imports/ImportsExports';

function PrivateRoute({ children }) {
  const token = useAuthStore((s) => s.token);
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="parcels" element={<ParcelList />} />
          <Route path="parcels/new" element={<ParcelForm />} />
          <Route path="parcels/:id" element={<ParcelDetail />} />
          <Route path="parcels/:id/edit" element={<ParcelForm />} />
          <Route path="measurements" element={<Measurements />} />
          <Route path="weather" element={<Weather />} />
          <Route path="chat" element={<Chat />} />
          <Route path="imports" element={<ImportsExports />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
